import React from 'react'

import { IconProps } from '../types'

export const LandMark = ({ className, width = 18, height = 19, fill }: IconProps) => (
  <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 18 19">
    <path d="M17.635 3.723 9.395.557a1.124 1.124 0 0 0-.79 0L.365 3.723A.563.563 0 0 0 0 4.25v1.298c0 .31.252.562.563.562h16.875c.31 0 .562-.251.562-.562V4.25a.562.562 0 0 0-.365-.527ZM2.25 7.235v5.625h-.563a.562.562 0 0 0-.562.563v1.687h15.75v-1.687a.562.562 0 0 0-.563-.563h-.562V7.235H13.5v5.625h-3.375V7.235h-2.25v5.625H4.5V7.235H2.25Zm15.188 9H.563a.562.562 0 0 0-.563.563v1.125c0 .31.252.562.563.562h16.875c.31 0 .562-.252.562-.562v-1.125a.562.562 0 0 0-.563-.563Z" />
  </svg>
)
